var node_cryptojs = require('node-cryptojs-aes');

// node-cryptojs-aes main object;
var CryptoJS = node_cryptojs.CryptoJS;

// custom json serialization format
var JsonFormatter = node_cryptojs.JsonFormatter;

const getData = async (query) => {
  console.log(query)
  var encrypted = CryptoJS.AES.encrypt(JSON.stringify(query.replace(/('null')/g, "''")), 'MIIDDDCCAfQCAQAwgZIxCzAJBgNVBAYTAklOMRQwEgYDVQQIDAtNYWhhcmFzaHRy', { format: JsonFormatter });

  // convert CipherParams object to json string for transmission
  var encrypted_json_str = JSON.parse(encrypted.toString());
  const data = await fetch(`${process.env.REACT_APP_API_DOMAIN_ROOT}/encryptionjwt.php`, {
    body: JSON.stringify({ query: encrypted_json_str, token: localStorage.getItem('token') }),
    method: "POST"
  })
    .then(r => {
      return r.json();
    }).catch(e => {
      return e
    })
  return data

};

export const sendOTP = (otp, phoneno) => {
  return fetch(
    ` https://japi.instaalerts.zone/httpapi/QueryStringReceiver?ver=1.0&key=csKYDQc4aYtEzwVJPXq7lA==&encrpt=0&dest=${phoneno}&send=PILAAC&text=${otp} is your OTP to Login to the Fevicryl App. Thanks.`,

    // `https://2factor.in/API/V1/3fc06904-2b59-11e9-9ee8-0200cd936042/SMS/${phoneno}/${otp}/Fevicryl+Team+-+Login+OTP`,
    {}
  )
    .then(r => r.json())
    .catch(e => {
      return e;
    });
};

export const documentUpload = ({ id, type, img }) => {
  console.log('idid', id);
  console.log('typetype', type);
  console.log('imgimg', img);
  var data = new FormData();
  const dataToSend = JSON.stringify([
    { id: btoa(id + new Date().toDateString()), type, img }
  ]);

  data.append("json_data", dataToSend);

  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    // xhr.withCredentials = true;
    xhr.addEventListener("readystatechange", function () {
      if (this.readyState === 4) {
        resolve(JSON.parse(this.responseText));
      }
    });

    // xhr.open("POST", `${process.env.REACT_APP_API_DOMAIN_ROOT}/s3/s3_upload_api.php`);

    // xhr.open("POST", `https://mpowerpidilite.herokuapp.com/s3_upload_api.php`);

    xhr.open("POST", `https://hobby-ideas.herokuapp.com/uploadImage.php`);

    // xhr.open("POST", `https://demohobbyideas.herokuapp.com/s3_upload_api.php`);

    xhr.send(data);
  });

  //
  // const body = new FormData
  // body.append("json_data", JSON.stringify([{ id: btoa(`${id}+${new Date().toDateString()}`), type, img }]))

  // return fetch(`${process.env.REACT_APP_API_DOMAIN_ROOT}/s3/s3_upload_api.php`, {
  //   body,
  //   headers: {
  //     "Content-Type": "multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW",
  //   },
  //   method: "POST"
  // }).then(r => {
  //
  //   return r.json()
  // }).catch(e => {
  //
  //   return e
  // })
};

export const imageUpload = ({ id, type, img }) => {
  var data = new FormData();
  console.log(id, "data=", img, type)
  const dataToSend = JSON.stringify([
    { id: btoa(id + new Date().toDateString()), type, img }
  ]);

  data.append("json_data", dataToSend);

  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    // xhr.withCredentials = true;

    xhr.addEventListener("readystatechange", function () {
      console.log("this => ", this)
    console.log("this.responseText => ", this.responseText)
    console.log("this.readyState => ", this.readyState)
      
      if (this.readyState === 4) {
        console.log("this.responseText => ", this.responseText)
        resolve(JSON.parse(this.responseText));
      }
    });
    xhr.open("POST", `https://hobby-ideas.herokuapp.com/uploadImage.php`);

    xhr.send(data);
  });
};

export const pdfUpload = ({ id, pdf, type }) => {
  var data = new FormData();
  console.log(id, pdf, type)

  const dataToSend = JSON.stringify([
    { id: btoa(id + new Date().toDateString()), type, img: pdf }
  ]);

  data.append("json_data", dataToSend);

  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    // xhr.withCredentials = true;

    xhr.addEventListener("readystatechange", function () {
      if (this.readyState === 4) {
        resolve(JSON.parse(this.responseText));
      }
    });

    // xhr.open("POST", `https://hobby-ideas.herokuapp.com/s3/s3_upload_api.php`);
    // xhr.open("POST", `${process.env.REACT_APP_API_UPLOAD_PDF}`);
    xhr.open("POST", `https://hobby-ideas.herokuapp.com/uploadPdf.php`);

    xhr.send(data);
  });
}

// export const pdfUpload = ({ id, type, img }) => {
//   console.log('pdfidid', id);
//   console.log('pdftypetype', type);
//   console.log('pdfimgimg', img);
//   var data = new FormData();
//   const dataToSend = JSON.stringify([
//     { id: btoa(id + new Date().toDateString()), type, img }
//   ]);

//   data.append("json_data", dataToSend);

//   return new Promise((resolve, reject) => {
//     var xhr = new XMLHttpRequest();

//     xhr.addEventListener("readystatechange", function () {
//       if (this.readyState === 4) {
//         resolve(JSON.parse(this.responseText));
//       }
//     });

//     xhr.open("POST", `https://mpowerpidilite.herokuapp.com/uploadPdf.php`);

//     xhr.send(data);
//   });
// };

export const SignInAPI = ({ phoneNumber, userType, password }) => {
  console.log(phoneNumber, userType, password)
  return fetch(`https://hobby-ideas.herokuapp.com/login.php`, {
    body: JSON.stringify({
      "user_type": userType,
      "mobile_no": phoneNumber,
      "password" : password
    }),
    method: "POST"
  }).then(r => r.json())
};

export const checkUserAPI = ({ phoneNumber, userType }) => {
  console.log(phoneNumber, userType);
  return fetch(`${process.env.REACT_APP_API_DOMAIN_ROOT}/sendOtpAPI.php`, { //checkuser.php
    body: JSON.stringify({
      "user_type": userType,
      "mobile_no": phoneNumber,
    }),
    method: "POST"
  }).then(r => r.json())
};

export const resetPasswordAPI = ({ userType, password, userSFID }) => {
  console.log( userType, password, userSFID)
  return fetch(`${process.env.REACT_APP_API_DOMAIN_ROOT}/updatepassword.php`, {
    body: JSON.stringify({
      "user_type": userType,
      "password" : password,
      "sfid": userSFID
    }),
    method: "POST"
  }).then(r => r.json())
};

export const login = ({ phoneNumber, userType }) => {
  return fetch(`${process.env.REACT_APP_API_DOMAIN_ROOT}/login.php`, {
    body: JSON.stringify({
      "user_type": userType,
      "mobile_no": phoneNumber
    }),
    method: "POST"
  }).then(r => r.json())
}

export const verify = ({
  otp,
  phoneNumber,
  role
}) => {
  console.log(otp, phoneNumber, role);
  const otpSTR = Number(otp);
  return fetch(`${process.env.REACT_APP_API_DOMAIN_ROOT}/verify.php`, {
    body: JSON.stringify({
      "user_type": role,
      "mobile_no": phoneNumber,
      "otp": otp
    }),
    method: "POST"
  }).then(r => r.json())
}

export default getData;
